// extracted by mini-css-extract-plugin
module.exports = {"linkItem":"LinkItem_linkItem___i_jS","inline":"LinkItem_inline__1QsoE"};